import styled from 'styled-components';

import { getSpacing, fontSize } from 'stylesheetB2b';
export const TimeSliderAndSongInfos = styled.div`
  flex: 1;

  /* setting a width here is necessary so that the container doesn't grow too much */
  width: 0;
  font-size: ${fontSize.large};
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 'auto';
  padding-right: ${getSpacing(6.4)};
`;
TimeSliderAndSongInfos.displayName = 'TimeSliderAndSongInfos';
